//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  TextField,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer';
import { ExpressionContext } from '../../../Context/ExpressionContext';
import { DataTypeSelect    } from '../DataTypeSelect/DataTypeSelect';

// === UTILS ===
import { keyframes } from 'components/utils';
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function RecordControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { updateExpression, records } = useContext( ExpressionContext );

  const [ field_name, setFieldName ] = useState( props.data?.name );
  const [ is_changed, setIsChanged ] = useState( false );

  let play_animation = false;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_field: {
      width: '40rem',
      animation: is_changed ? `${keyframes.confirm} 1s 1` : '',
    },
  }

  const SELECT_FIELD = {
    sx          : _styles.select_field,
    id          : 'field-select',
    options     : records,
    value       : field_name,
    size        : 'small',
    freeSolo    : true,
    onChange    : onChange,
    onKeyDown   : onKeyDown,
    renderInput : (params) => <TextField {...params}  label="Field" />,
    disableClearable : true,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    const name = value?.value ? value.value : value;
    updateExpression( props.id , { name } )
    setIsChanged( true );
  }
  
  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    setIsChanged( false );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <DataTypeSelect id={props.id} type={props.data?.type} />
        <Spacer />
        <Autocomplete { ...SELECT_FIELD } />
      </>
    );
  }

  //#endregion

  return display();
}
